module.exports = __webpack_public_path__ + "static/media/home-kitchen.7a5114ee.png";